const gallery = $("#gallery_box");
$(".block_image").on("click", (e) => {
	const imageIndex = e.currentTarget.getAttribute("data-index");
	e.preventDefault();
	if (gallery.hasClass("hide")) {
		gallery.removeClass("hide");
		$(".post_image_grid").addClass("hide");
		const swiper = new Swiper(".sswi", {
			scrollbar: {
				el: ".swiper-scrollbar",
				hide: true,
			},
			init: true,
			initialSlide: imageIndex,
		});
	}
});
gallery.on("click", (e) => {
	const swiper = document.querySelector(".swiper").swiper;
	e.preventDefault();
	const gallery = $("#gallery_box");
	if (gallery.hasClass("hide")) {
		$(gallery).removeClass("hide");
	} else {
		$("#gallery_box").addClass("hide");
		$(".post_image_grid").removeClass("hide");
		swiper.destroy();
	}
});
$("#blog_email_signup").on("submit", function (e) {
	e.preventDefault();
	const email = $("#k_id_blog_email").val();
	let eReg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
	if (eReg !== true) {
		$(".email_error").removeClass("none");
		$("#k_id_blog_email").addClass("form_error_bb");
		throw new Error("Invalid Email Entry");
	}
	const formId = $("input[name='z']").val().replace(/'/g, "");
	console.log(`FORM ID`, formId);
	$.ajax({
		async: true,
		crossDomain: true,
		type: "POST",
		headers: {
			"content-type": "application/x-www-form-urlencoded",
			"cache-control": "no-cache",
		},
		url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
		data: {
			g: formId,
			$fields: "$source",
			email: email,
			$source: "Menu Navigation",
			$method_type: "Klaviyo Form",
			$method_id: "embed",
			$consent_version: "Embed default text",
		},
	})
		.done(function (response) {
			console.log(response);
			$("#blog_email_signup .klaviyo_field_group input[type=submit]").prop(
				"disabled",
				true
			);
			$(".klaviyo_field_group").addClass("none");
			$(".success_message").removeClass("none");
			setTimeout(() => {
				$(".success_message").remove();
			}, 3000);
		})
		.fail(function (xhr, textStatus, errorThrown) {
			// error
			$(".email_error").removeClass("none");
			$("#k_id_blog_email").addClass("form_error_bb");
		});
});
